import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import CommonProviders from './CommonProviders';
import reportWebVitals from './reportWebVitals';
import { HideFeature, ShowFeature } from '@crm-in-store/crmis-feature-flags';
import CountryNotSupported from './components/CountryNotSupported';
import { Loader } from '@pvh/loader';
import { FeatureFlags } from '@crm-in-store/crmis-feature-flags/build/api/getCrmisFeatureFlags';

const AppV2 = lazy(() => import('./AppV2'));
const AppV3 = lazy(() => import('./AppV3'));

const App = () => {
  // If 'debugFlags' is defined, will override all feature flag values.
  const debugFlags = getFlagOverrides();

  return (
    <CommonProviders>
      <Suspense fallback={<Loader />}>
        <HideFeature
          flagsToBeTruthy={['signUpAvailable']}
          Loader={<Loader />}
          allFeatureFlags={debugFlags}
        >
          <CountryNotSupported />
        </HideFeature>

        <ShowFeature
          flagsToBeTruthy={['membershipAndLoyalty']}
          Loader={<Loader />}
          allFeatureFlags={debugFlags}
        >
          <AppV3 />
        </ShowFeature>

        <HideFeature
          flagsToBeTruthy={['membershipAndLoyalty']}
          Loader={<Loader />}
          allFeatureFlags={debugFlags}
        >
          <AppV2 />
        </HideFeature>
      </Suspense>
    </CommonProviders>
  );
};

/**
 * Get object that overrides retrieves feature flags. Used for local
 * development.
 * @returns Undefined will result in no flags being overridden.
 */
const getFlagOverrides = (): FeatureFlags | undefined => {
  if (process.env.NODE_ENV === 'production') {
    // In production feature flags should always be used.
    return undefined;
  }

  if (process.env.REACT_APP_OVERRIDE_VERSION === undefined) return undefined;

  const areFlagsOverridden =
    process.env.REACT_APP_OVERRIDE_VERSION === 'v2' ||
    process.env.REACT_APP_OVERRIDE_VERSION === 'v3';

  return {
    signUpAvailable: areFlagsOverridden,
    membershipAndLoyalty: process.env.REACT_APP_OVERRIDE_VERSION === 'v3',
  };
};

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
